export default __webpack_public_path__ + "static/media/Action_leave.720bb252.wav";